import instanciaAxios from './InterceptorAxios';

const servicioCargaxml = {
	cargaxml(xml) {
		return instanciaAxios.post('/carga/xml.json',xml);
  }
}

export default servicioCargaxml;